import { motion } from 'framer-motion';
import styled from 'styled-components';
import { infiniteRotationAnimation } from 'styles/animations';
import { BREAKPOINTS } from 'styles/media';

import { CompanyLogoContainer } from '../CompanyLogo/styled';
import { ShareBarLikeCTAWrapper } from '../ShareBar/ShareBarLikeCTA/styled';

export const CommentWrapper = styled(motion.div)`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 16px;

  padding: 16px;

  border-radius: ${({ theme }) =>
    theme.hasReply && theme.hasCommentsOpen ? '16px 16px 0px 16px' : '16px'};

  transition: background 0.1s ease-in-out;
  ${({ theme }) =>
    theme.aboutToDelete &&
    `
    background: #F7F7F7;
  `}

  ${({ theme }) =>
    theme.showDeleteState &&
    `
    background: #F7F7F7;
  `}

  ${({ theme }) =>
    theme.isHighlighted &&
    `
    box-shadow: 0px 6px 24px 0px rgba(0, 0, 0, 0.1);
    background: rgba(255, 210, 95, 0.10);
  `}

  position: relative;
`;

export const CommentHeaderWrapper = styled(motion.div).attrs({
  exit: {
    height: 0,
    overflow: 'hidden',
  },
})`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  ${BREAKPOINTS.tablet} {
    flex-direction: column-reverse;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const CommentHeaderPersonInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CommentHeaderPersonInfoTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const CommentHeaderPersonInfoName = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;

  color: var(--color-text);
`;

export const CommentHeaderPersonInfoRole = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: normal;

  color: var(--color-text);

  & ${CompanyLogoContainer} {
    transform: translateY(5px);
  }
`;

export const CommentHeaderRightContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  ${BREAKPOINTS.tablet} {
    align-self: flex-end;
  }
`;

export const CommentHeaderRightContainerIconWrapper = styled.div`
  width: 24px;
  height: 24px;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  user-select: none;
`;

export const CommentHeaderDate = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: normal;

  color: rgba(23, 28, 51, 0.5);
`;

export const CommentContent = styled.div`
  white-space: break-spaces;
  & p {
    font-weight: 400;
    font-size: 18px;
    line-height: normal;

    color: var(--color-text);
  }

  & strong {
    font-weight: 700;
  }
`;

export const CommentBottomWrapper = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const CommentBottomWrapperIconsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CommentBottomWrapperIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  & [data-liked='false'] {
    opacity: 0.5;
  }

  ${ShareBarLikeCTAWrapper} {
    flex-direction: row;
    padding: 0px;
  }

  cursor: pointer;
  user-select: none;
`;

export const CommentBottomChildMessagesCounter = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;

  color: rgba(23, 28, 51, 0.5);

  white-space: nowrap;
`;

export const CommentBottomReply = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  color: var(--color-text);
  cursor: pointer;

  white-space: nowrap;
`;

export const CommentDeletedStateText = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: normal;

  color: rgba(23, 28, 51, 0.5);
`;

//ACTION MENU
export const CommentActionMenuWrapper = styled(motion.div).attrs({
  initial: { maxHeight: 0, padding: '0px 16px' },
  animate: { maxHeight: 500, padding: '16px 16px' },
  exit: { maxHeight: 0, padding: '0px 16px' },
  transition: { duration: 0.1 },
})`
  min-width: 162px;

  padding: 16px;

  border-radius: 16px;
  background: #ffffff;

  box-shadow: 0px 6px 24px 0px rgba(0, 0, 0, 0.1);

  overflow: hidden;
  z-index: 1000;
`;

export const CommentActionMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CommentActionMenuItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  & .spinner-icon {
    ${infiniteRotationAnimation()}
  }

  cursor: pointer;
`;

export const CommentActionMenuItemLabel = styled.span`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;
  color: var(--color-text);
`;
